import { ActionTypes } from "@/App/constants/actionTypes";
import { BatchManualClaimTypes } from "@/types";

type GetManualClaim = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM;
  payload: string;
};

export const getManualClaim = (id: string): GetManualClaim => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM,
    payload: id,
  };
};

type GetManualClaimResultAction = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_RESULTS;
  payload: BatchManualClaimTypes.BatchManualClaim;
};

export const getManualClaimResults = (data: BatchManualClaimTypes.BatchManualClaim): GetManualClaimResultAction => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_RESULTS,
    payload: data,
  };
};

export type GetBatchManualClaimActions = GetManualClaim | GetManualClaimResultAction;
